/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Mcp_Tools_HelpInputs */

const en_directory_mcp_tools_help = /** @type {(inputs: Directory_Mcp_Tools_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Each tool is a thin wrapper over the REST API — same scopes, same error codes.`)
};

const zh_directory_mcp_tools_help = /** @type {(inputs: Directory_Mcp_Tools_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`每个工具都是 REST API 的薄封装——同样的权限、同样的错误码。`)
};

/**
* | output |
* | --- |
* | "Each tool is a thin wrapper over the REST API — same scopes, same error codes." |
*
* @param {Directory_Mcp_Tools_HelpInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_mcp_tools_help = /** @type {((inputs?: Directory_Mcp_Tools_HelpInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Mcp_Tools_HelpInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_mcp_tools_help(inputs)
	return zh_directory_mcp_tools_help(inputs)
});
export { directory_mcp_tools_help as "directory.mcp.tools_help" }